import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import * as en from './locale/en.json'
import * as fi from "./locale/fi.json"
import * as sv from "./locale/sv.json"
import * as en_blog from './locale/blogs-en.json'
import * as fi_blog from './locale/blogs-fi.json'
import * as sv_blog from './locale/blogs-sv.json'

const en_texts = { ...en, ...en_blog}
const fi_texts = { ...fi, ...fi_blog}
const sv_texts = { ...sv, ...sv_blog}

// the translations
const resources = {
  en: {
    translation: en_texts
  },
  fi: {
    translation: fi_texts
  },
  sv: {
    translation: sv_texts
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .init({
    resources,
    fallbackLng: 'en',

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;


// WEBPACK FOOTER //
// ./src/i18n.js